export enum ReservationStatus{
    Reservation = 0,
    CheckIn = 1,
    CheckOut = 2,
    Cancel = 3,
    NoShow = 4,
    WaitingList = 5
}
export enum TypeReservaion{
    ReservationIndividual = 1,
    ReservationGroup = 2,
    ReservationWalkin = 3
}
export enum ExpandStatus{
    PM = 6,
    Wakin = 7
}
export enum CodeDmucTuyChon{
    codeFormatNumber = 'FMNUMBER'
}